import { forwardRef } from '@heroui/system';
import { extendVariants, Radio, RadioProps } from '@heroui/react';

const CustomRadio = extendVariants(Radio, {
  variants: {
    size: {
      sm: {
        label: 'text-s-m',
      },
      md: {
        label: 'text-m-m',
      },
      lg: {
        label: 'text-l-m',
      },
    },
    color: {
      default: {
        base: ['inline-flex', 'm-0', 'items-center', 'cursor-pointer', 'tmdx-radio', 'isolation-isolate'],
        wrapper: [
          'bg-transparent',
          'tmdx-radio__wrapper',
          'border-base-40',
          'group-data-[hover=true]:not([data-selected=true]):bg-transparent',
          'group-data-[selected=true]:group-data-[hover=true]:bg-base-40',
          'group-data-[selected=true]:border-base-5',
          'group-data-[hover=true]:border-base-5',
          'group-data-[hover=true]:bg-transparent',
        ],
        control: ['tmdx-radio__control', 'bg-base-5', 'z-1'],
        label: 'tmdx-radio__label',
        description: 'text-s-r! text-base-40 tmdx-radio__description',
      },
      danger: {
        wrapper: ['border-danger', 'data-[selected=true]:border-danger'],
        control: 'bg-danger',
      },
    },
  },
  defaultVariants: {
    color: 'default',
    size: 'sm',
  },
});

const RadioWrapper = forwardRef<'input', Omit<RadioProps, 'ref'>>((props, ref) => {
  return <CustomRadio ref={ref} {...props} />;
});

RadioWrapper.displayName = 'RadioWrapper';

export default RadioWrapper;
